import * as React from "react";
const SvgVisaLight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={20}
    viewBox="0 0 28 20"
    {...props}
  >
    <rect
      width={27}
      height={18}
      x={0.5}
      y={1}
      fill="#fff"
      stroke="#F3F3F3"
      rx={3.5}
    />
    <path
      fill="#15195A"
      d="M12.433 13.531h-1.865l1.166-6.65h1.864zM19.19 7.043a5 5 0 0 0-1.672-.283c-1.841 0-3.138.905-3.146 2.2-.015.955.929 1.486 1.634 1.804.721.326.967.538.967.828-.008.446-.583.651-1.12.651-.744 0-1.143-.106-1.749-.354l-.245-.106-.261 1.493c.437.184 1.242.347 2.079.354 1.956 0 3.23-.892 3.244-2.271.008-.758-.49-1.338-1.564-1.812-.652-.304-1.052-.509-1.052-.82.008-.283.338-.573 1.074-.573a3.4 3.4 0 0 1 1.388.254l.17.071z"
    />
    <path
      fill="#15195A"
      fillRule="evenodd"
      d="M22.527 6.88h1.441l1.504 6.651h-1.726l-.222-.998H21.13l-.392.998h-1.956l2.77-6.098c.191-.432.529-.552.973-.552m-.115 2.435-.745 1.86h1.55c-.077-.332-.43-1.924-.43-1.924l-.13-.573c-.055.147-.134.35-.188.487zM2.49 6.88h2.999c.406.015.736.135.844.56l.651 3.055v.001l.2.92L9.01 6.88h1.971l-2.93 6.643H6.08L4.418 7.746a8 8 0 0 0-1.959-.73z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVisaLight;
